import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OcFormEditorItemList } from "oc/components";
import { useOcFormEditorSelector } from "oc/hooks";
import getCountries from "oc/utils/get-countries";

interface OcFormEditorCountrySelectorProps {
  name: string;
  label: string;
  value: string;
  onChange: (field: string, value: string) => void;
  error?: string;
}

export const OcFormEditorCountrySelector: React.FC<
  OcFormEditorCountrySelectorProps
> = ({ name, label, value, onChange, error }) => {
  const { i18n } = useTranslation();
  const countries = getCountries(i18n.language);

  useEffect(() => {
    if (!value) {
      const defaultValue = "HUN";
      onChange("country", defaultValue);
    }
  }, [value, onChange]);

  const {
    list,
    search,
    selectedItem,
    handleSearch,
    handleClearSearch,
    handleHasMore,
  } = useOcFormEditorSelector({
    value,
    list: countries,
  });

  return (
    <OcFormEditorItemList
      search={search}
      onSearch={handleSearch}
      onChange={onChange}
      onClearSearch={handleClearSearch}
      list={list}
      onScroll={handleHasMore}
      value={selectedItem}
      label={label}
      name={name}
      error={!!error}
    />
  );
};

export default OcFormEditorCountrySelector;
